import { API } from "../store"
import handleCatch from "../lib/catch"
import serialize from "../store/serialize"
import { isArray, orderBy } from "lodash"
import { getCrew } from "./crew"
import shootStatus from "../lib/shootStatus"
import store from "../store"
import { useEffect } from "react"
export const TOGGLE_SHOOT_DIALOG = "SHOOT::TOGGLE_SHOOT_DIALOG"

export const TOGGLE_EDIT_SHOOT_DIALOG = "SHOOT::TOGGLE_EDIT_SHOOT_DIALOG"
export const TOGGLE_CHANGE_REPRESENTATIVE_DIALOG =
  "SHOOT::TOGGLE_CHANGE_REPRESENTATIVE_DIALOG"
export const SET_SHOOTS = "SHOOT::SET_SHOOTS"
export const SET_CLIENT_COMPANY_SHOOTS = "SHOOT::SET_CLIENT_COMPANY_SHOOTS"
export const SET_SHOOT_DIALOG_CREW = "SHOOT::SET_SHOOT_DIALOG_CREW"
export const UPDATE_SHOOT = "SHOOT::UPDATE"
export const DELETE_SHOOT_ROLE = "DELETE::SHOOT_ROLE"
export const UPDATE_SHOOTS_ARRAY = "SHOOT::UPDATE_SHOOTS_ARRAY"
export const SET_SHOOTS_LENGTH = "SHOOT::SET_SHOOTS_LENGTH"
export const SORT_SHOOTS = "SHOOT::SORT_SHOOTS"
export const CLEAR_SHOOTS = "SHOOT::CLEAR_SHOOTS"
export const SET_CURRENT_SHOOT = "SHOOT::SET_CURRENT_SHOOT"
export const NOTIFY_GET_SHOOT_BY_ID = "SHOOT::NOTIFY_GET_SHOOT_BY_ID"
export const NOTIFY_GET_SHOOTS = "SHOOT::NOTIFY_GET_SHOOTS"

export const SET_EDIT_SHOOT = "SHOOT::SET_EDIT_SHOOT"
export const TOGGLE_CONFIRM_DUPLICATE_DIALOG = "TOGGLE_CONFIRM_DUPLICATE_DIALOG"
export const TOGGLE_CONFIRM_SAVE_SHOOT_DIALOG =
  "TOGGLE_CONFIRM_SAVE_SHOOT_DIALOG"
export const TOGGLE_ROLE_DIALOG = "SHOOT::TOGGLE_ROLE_DIALOG"
export const SET_ROLE_FOR_CREW = "SHOOT::SET_ROLE_FOR_CREW"

export const SET_ACTIVE_ROLE = "SHOOT::SET_ACTIVE_ROLE"
export const SET_TOTAL_NUMBERS = "SHOOT::SET_TOTAL_NUMBERS"
export const RECALL_SHOOT = "SHOOT::RECALL_SHOOT"
export const UPDATE_SHOOT_ROLE = "SHOOT::UPDATE_SHOOT_ROLE"

export const notifyGetShoots = payload => {
  return {
    type: NOTIFY_GET_SHOOTS,
    payload,
  }
}

export const toggleShootDialog = payload => {
  return {
    type: TOGGLE_SHOOT_DIALOG,
    payload,
  }
}

export const setActiveShootRole = (shootRole = null) => {
  return {
    type: SET_ACTIVE_ROLE,
    shootRole,
  }
}

export const toggleChangeRepresentativeDialog = payload => {
  return {
    type: TOGGLE_CHANGE_REPRESENTATIVE_DIALOG,
    payload,
  }
}

export const setRoleForCrew = (payload = null) => {
  return {
    type: SET_ROLE_FOR_CREW,
    payload,
  }
}

export const toggleRoleDialog = payload => {
  return {
    type: TOGGLE_ROLE_DIALOG,
    payload,
  }
}

export const recallShoot = payload => {
  return {
    type: RECALL_SHOOT,
    payload,
  }
}

export const toggleConfirmSaveShootDialog = payload => {
  return {
    type: TOGGLE_CONFIRM_SAVE_SHOOT_DIALOG,
    payload,
  }
}

export const toggleEditShootDialog = (payload = false) => {
  return {
    type: TOGGLE_EDIT_SHOOT_DIALOG,
    payload,
  }
}

export const toggleDuplicateShootDialog = (payload = false) => {
  return {
    type: TOGGLE_CONFIRM_DUPLICATE_DIALOG,
    payload,
  }
}

export const setShoots = payload => {
  return {
    type: SET_SHOOTS,
    payload,
  }
}

export const setClientCompanyShoots = payload => {
  return {
    type: SET_CLIENT_COMPANY_SHOOTS,
    payload,
  }
}

export const setTotalNumbers = payload => {
  return {
    type: SET_TOTAL_NUMBERS,
    payload,
  }
}

export const setEditShoot = (payload = {}) => {
  return {
    type: SET_EDIT_SHOOT,
    payload,
  }
}

export const setShootDialogCrew = payload => {
  return {
    type: SET_SHOOT_DIALOG_CREW,
    payload,
  }
}

export const _updateShoot = (shootId, data) => {
  return {
    type: UPDATE_SHOOT,
    shootId,
    data,
  }
}
export const deleteShootRoleFromShoots = (shootId, userId) => {
  return {
    type: DELETE_SHOOT_ROLE,
    shootId,
    userId,
  }
}

export const updateShootRoleFromShoots = (shootId, userId, data) => {
  return {
    type: UPDATE_SHOOT_ROLE,
    shootId,
    userId,
    data,
  }
}

export const updateShootsArray = payload => {
  return {
    type: UPDATE_SHOOTS_ARRAY,
    payload,
  }
}

export const sortShoots = payload => {
  return {
    type: SORT_SHOOTS,
    payload,
  }
}

export const setShootLength = payload => {
  return {
    type: SET_SHOOTS_LENGTH,
    payload,
  }
}
export const clearShoots = payload => {
  return {
    type: CLEAR_SHOOTS,
    payload,
  }
}

export const setCurrentShoot = payload => {
  return {
    type: SET_CURRENT_SHOOT,
    payload,
  }
}

export const notifyGetShootById = payload => {
  return {
    type: NOTIFY_GET_SHOOT_BY_ID,
    payload,
  }
}

export const getShootbyId = shootId => dispatch => {
  return new Promise((resolve, reject) => {
    const call = () => {
      API.get(`/getShootbyId/${shootId}`)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(res => res.body)
        .then(res => {
          if (res && res.shoots && res.shoots.length === 1) {
            let shootsLength = res.shootsLength
            dispatch(setShootLength(shootsLength))
            dispatch(
              setShoots(
                res.shoots[0].map(shoot => {
                  try {
                    shoot.location = shoot.location
                      ? JSON.parse(shoot.location)
                      : null
                    shoot.status = shootStatus(shoot)
                  } catch (e) {
                    console.log(e)
                  }

                  return {
                    ...shoot,
                  }
                })
              )
            )

            resolve(res.shoots[0])
          } else {
            reject(res)
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    }
    call()
  })
}

export const getCalenderShoots = sending => dispatch => {
  let storeData = store.getState()
  let url = storeData.companies.activeCompany
    ? `/shoots/getCalenderShoots/`
    : `/shoots/getCalenderShoots/?company_id=2`
  return new Promise((resolve, reject) => {
    const call = () => {
      API.post(url)
        .send(sending)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(res => res.body)
        .then(res => {
          // console.log('response2', res);
          // console.log('sending2', sending);
          if (res != null) {
            let oldShootsRemoved = store.getState()
            oldShootsRemoved = oldShootsRemoved.shoots.shoots

            if (oldShootsRemoved.length) {
              dispatch(clearShoots())
            }
            if (res.shoots[0] && Array.isArray(res.shoots[0])) {
              dispatch(
                setShoots(
                  res.shoots[0].map(shoot => {
                    try {
                      shoot.location = JSON.parse(shoot.location)
                      shoot.status = shootStatus(shoot)
                    } catch (e) {
                      // console.log(e)
                    }
                    return {
                      ...shoot,
                    }
                  })
                )
              )
              let totalsObject = {
                shoot_count: res.shoot_count,
                total_billable: res.total_billable,
                total_expense: res.total_expense,
                total_profit: res.total_profit,
              }
              dispatch(setTotalNumbers(totalsObject))
              resolve(res.shoots[0])
            } else {
              resolve([])
            }
          } else {
            reject(res)
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    }
    call()
  })
}

export const createShoot = shoot => dispatch => {
  return new Promise((resolve, reject) => {
    const call = () => {
      API.post(`/shoots`)
        .send(shoot)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(res => res.body)
        .then(result => {
          return new Promise((resolve, reject) => {
            API.get("/shoots/notify/" + result.shoots[0].id)
              .then(res => resolve(result))
              .catch(err => {
                console.log(err)
                resolve(result)
              })
          })
        })
        .then(res => resolve(res))
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    }
    call()
  })
}

export const getShoots = (currentPage, sortObject, dateFilter) => dispatch => {
  return new Promise((resolve, reject) => {
    const call = () => {
      // API.get(`/shoots`)
      API.post(`/shoots/shootslist/${currentPage}/${dateFilter}`)
        .send(sortObject)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(res => res.body)
        .then(res => {
          let shootsLength = res.shootsLength
          dispatch(setShootLength(shootsLength))
          if (res && res.shoots && res.shoots.length === 1) {
            dispatch(
              setShoots(
                res.shoots[0].map(shoot => {
                  try {
                    shoot.location = JSON.parse(shoot.location)
                    shoot.status = shootStatus(shoot)
                  } catch (e) {
                    console.log(e)
                  }
                  return {
                    ...shoot,
                  }
                })
              )
            )
            resolve(res.shoots[0])
          } else {
            reject(res)
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    }
    call()
  })
}

export const shootsByCrew = data => dispatch => {
  // console.log('data',data);
  // getCalenderShoots();
  return new Promise((resolve, reject) => {
    const call = () => {
      API.post(`/shootsByCrewNew`)
        .send(data)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(res => res.body)
        .then(res => {
          if (
            res &&
            res.shoots &&
            res.shoots.length === 1 &&
            res.shoots[0] != null
          ) {
            resolve(
              res.shoots[0].map(shoot => {
                try {
                  // shoot.location = JSON.parse(shoot.location)
                  shoot.status = shootStatus(shoot)
                } catch (e) {
                  console.log(e)
                }
                return {
                  ...shoot,
                }
              })
            )
          } else {
            // resolve(res)
            // reject(res)
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    }
    call()
  })
}

export const getShootDetails = shootId => dispatch => {
  return new Promise((resolve, reject) => {
    const call = () => {
      API.get(`/shoots/${shootId}/details`)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(res => res.body)
        .then(res => {
          if (res && res.shoots && res.shoots.length === 1) {
            try {
              res.shoots[0].location = JSON.parse(res.shoots[0].location)
            } catch (e) {
              console.log(e)
            }
            dispatch(setShoots([res.shoots[0]]))
            resolve(res.shoots[0])
          } else {
            reject(res)
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    }
    call()
  })
}

export const getCompanyShoots = clientCompanyId => dispatch => {
  return new Promise((resolve, reject) => {
    const call = () => {
      API.get(`/shoots/company/${clientCompanyId}`)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(res => res.body)
        .then(res => {
          if (res && res.shoots && res.shoots.length >= 1) {
            // try {
            //   res.shoots[0].location = JSON.parse(res.shoots[0].location)
            // } catch (e) {
            //   console.log(e)
            // }
            dispatch(setClientCompanyShoots([res.shoots]))
            resolve(res.shoots[0])
          } else {
            reject(res)
          }
          resolve(res)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    }
    call()
  })
}

export const searchShootsCrew = (query, shootId) => {
  return dispatch => {
    const iteratees = [o => o.ratings.length, "last_name"]
    const orders = ["desc", "asc"]

    const deferred = new Promise((resolve, reject) => {
      const call = API.post(`/shoots/users/search/shootId/${shootId}`)
        .send(query)
        .then(response => response.body)
        .then(response => {
          if (response.message !== "No users found") {
            serialize("user", response.data).then(response => {
              const orderedCrew = orderBy(
                response,
                ["master_rating"].concat(iteratees),
                ["desc"].concat(orders)
              )
              resolve(orderedCrew)
            })
          } else {
            resolve([])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const updateShootRole = (shootId, roleId, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.put(`/shoots/${shootId}/roles/${roleId}`)
        .send(data)
        .then(response => response.body)
        .then(result => {
          return new Promise((resolve, reject) => {
            API.get("/shoots/notify/" + result.shoots[0].id)
              .then(res => resolve(result))
              .catch(err => {
                console.log(err)
                resolve(result)
              })
          })
        })
        .then(response => {
          dispatch(
            _updateShoot(
              shootId,
              response.shoots.map(shoot => {
                try {
                  shoot.location = JSON.parse(shoot.location)
                  shoot.status = shootStatus(shoot)
                } catch (e) {
                  console.log(e)
                }
                return {
                  ...shoot,
                }
              })
            )
          )
          if (data.user_id) {
            dispatch(getCrew(data.user_id)).then(() => {
              resolve(response.shoots[0])
            })
          } else {
            resolve(response.shoots[0])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const deleteShootGlue = (shootId, glueId, table) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.delete(`/shoots/${shootId}/${table}/${glueId}`)
        .then(response => response.body)
        .then(result => {
          return new Promise((resolve, reject) => {
            API.get("/shoots/notify/" + result.shoots[0].id)
              .then(res => resolve(result))
              .catch(err => {
                console.log(err)
                resolve(result)
              })
          })
        })
        .then(response => {
          resolve(response.shoots[0])
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const addUserToRole = (shootRoleId, data, shootId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.put(`/shoot/shoot_roles/${shootRoleId}`)
        .send(data)
        .then(response => response.body)
        .then(result => {
          return new Promise((resolve, reject) => {
            API.get("/shoots/notify/" + shootId)
              .then(res => resolve(result))
              .catch(err => {
                console.log(err)
                resolve(result)
              })
          })
        })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const createShootGlue = (shootId, table, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.post(`/shoots/${shootId}/${table}`)
        .send(data)
        .then(response => response.body)
        .then(result => {
          return new Promise((resolve, reject) => {
            API.get("/shoots/notify/" + result.shoots[0].id)
              .then(res => resolve(result))
              .catch(err => {
                console.log(err)
                resolve(result)
              })
          })
        })
        .then(response => {
          resolve(response.shoots[0])
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const updateShoot = (shootId, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.put(`/shoots/${shootId}`)
        .send(data)
        .then(response => response.body)
        .then(result => {
          return new Promise((resolve, reject) => {
            API.get("/shoots/notify/" + shootId)
              .then(res => resolve(result))
              .catch(err => {
                console.log(err)
                resolve(result)
              })
          })
        })
        .then(response => {
          dispatch(
            _updateShoot(
              shootId,
              response.shoots.map(shoot => {
                try {
                  shoot.location = JSON.parse(shoot.location)
                  shoot.status = shootStatus(shoot)
                } catch (e) {
                  console.log(e)
                }
                return {
                  ...shoot,
                }
              })
            )
          )
          dispatch(updateCalendars(shootId))
          if (data.user_id) {
            dispatch(getCrew(data.user_id)).then(() => {
              resolve(response.shoots[0])
            })
          } else {
            resolve(response.shoots[0])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const deleteShoot = shootId => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    const call = API.delete(`/calendar/delete/${shootId}`)
      .then(res => API.delete(`/calendar/delete_master/${shootId}`))
      .then(res => API.delete(`/shoots/${shootId}`))
      .then(response => response.body)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        handleCatch(err, dispatch)
          .then(call)
          .catch(reject)
      })
  })
  return deferred
}

export const createCalendars = shootId => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    const call = API.get(`/calendar/create_event/${shootId}`)
      .then(response => response.body)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        handleCatch(err, dispatch)
          .then(call)
          .catch(reject)
      })
  })
  return deferred
}

export const createMasterCalendar = shootId => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    const call = API.get(`/calendar/create_master/${shootId}`)
      .then(response => response.body)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        handleCatch(err, dispatch)
          .then(call)
          .catch(reject)
      })
  })
  return deferred
}

export const updateCalendars = shootId => dispatch => {
  // debugger;
  const deferred = new Promise((resolve, reject) => {
    const call = API.get(`/calendar/update_master/${shootId}`)
      .then(res => API.get(`/calendar/update/${shootId}`))
      .then(response => response.body)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        handleCatch(err, dispatch)
          .then(call)
          .catch(reject)
      })
  })
  return deferred
}
